import moment from "moment";
import config from "../config/config";

function getTicketTime(value) {
  if (value)
    return moment(value, config.settings.timeFormatParsing).format(
      config.settings.ticketTimeFormat
    );
  else return "";
}

const detailedDate = (val, format = "DD-MM-YYYY HH:mm") =>
  val ? moment(val).format(format) : "";

export { detailedDate, getTicketTime };
